
import { takeUntil } from 'rxjs/operators';
//++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//
//++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//

import { Location } from '@angular/common';
import { Component, Input, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';

import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import {  Subject } from 'rxjs';
//shared libs
import {  ToastService, SelectizeComponent } from '../../blocks';
import { AppCodeGroup, ControlsParams, UserSessionService } from '../../shared';
import { StepperComponent } from '../../blocks';
import { UsersGroupComponent } from '../usersGroups/usersGroup.component';
//services
import { User, UserService} from './user.service';
import { TranslateService } from '@ngx-translate/core';
//++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//
//++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//


@Component({
    selector: 'sanabel-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css']

})
export class UserComponent implements OnInit, OnDestroy, AfterViewInit {
    activeTab: number;
    error_messages = {

        'password': [
            { type: 'required', message: 'password is required.' },
            { type: 'minlength', message: 'password length.' },
            { type: 'maxlength', message: 'password length.' }
        ],
        'confirmpassword': [
            { type: 'required', message: 'password is required.' },
            { type: 'minlength', message: 'password length.' },
            { type: 'maxlength', message: 'password length.' }
        ],
    }
    @Input() defaultGroupCode: number;
    editUser: User = <User>{};
    controlsParams: ControlsParams;
    userForm: UntypedFormGroup;
    userCode: number;
    defaultGroup: number;
    defaultPassword: any;
    password: any;
    confirmPassword: any
    updateDate: Date;
    //++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//
    @Input() myStepNumber: number;
    @Input() stepperComponent: StepperComponent;
    @ViewChild('usersGroupComponent') usersGroupComponent: UsersGroupComponent;
    @ViewChild(SelectizeComponent) seclOginSeclectize: SelectizeComponent;
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    //++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//
    constructor(
        private _userService: UserService,
        private _fb: UntypedFormBuilder,
        private _location: Location,
        public translate: TranslateService,
        private _userSessionService: UserSessionService,
        private _toastService: ToastService) {

        this.controlsParams = new ControlsParams(555, AppCodeGroup.Buttons, true);

        //++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//


    }
    onClicked(e: number): void {
        switch (e) {
            case 1: //save code
                this.save();
                break;
            default:
                this.cancel();

        }
    }

    // initialize bank form
    userInit() {
        this.userForm = this._fb.group({
            userID: [0],
            empId: ['', Validators.required],
            admin: 0,
            defaultLang: 0,
            secondLang: 0,
            userName: ['', Validators.required],
            updateSecLoginUserName: [''],
            mappedUserName :[''],
            pacsPassword: [''],
            updateDate: [''],
            risFlag: 0,
            // password: ['', Validators.required],
            password: new UntypedFormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(30),
                Validators.pattern('/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/')
            ])),
            workEncrypLink: 0,
            active: [1],
            defaultGroup: ['', Validators.required],
            defaultBranch: ['', Validators.required],
            confirmPassword: new UntypedFormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(30),
                Validators.pattern('/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/')
            ])),
        },
            {
                //  validators: this.password.bind(this),

            })

    }
    ////////////////////////////////////////////////////////#Gouhar///////////////////////////////////////////

    activUserStepper$() {

        if (this.stepperComponent) {
            this.stepperComponent.getCurrentStep().pipe(
                takeUntil(this.ngUnsubscribe))
                .subscribe((step: any) => {
                    if (step && step.serial == this.myStepNumber)

                        var tempUser = this.selectedUserObj();
                    if (tempUser)
                        if (Object.keys(tempUser).length != 0) {
                            this._userSessionService.setSessionKey("editUserPassEnc", tempUser['password']);
                            tempUser['password'] = null;
                            tempUser['confirmPassword'] = null;
                            this.userForm.get('confirmPassword').setValue(null);
                            this.userForm.get('password').clearValidators();
                            this.userForm.get('confirmPassword').clearValidators();
                            this.userForm.patchValue(tempUser);
                            this.userForm.get('empId').setValue(tempUser['empID']);
                            if (this.usersGroupComponent) {
                                this.usersGroupComponent.getGroups(tempUser);
                            }
                            if (this.seclOginSeclectize) {
                                this.seclOginSeclectize.setFastSearchKey('Type', tempUser['userID']);
                            }

                        }
                        else {
                            this.userForm.get('password').setValidators(Validators.required);
                            this.userForm.get('confirmPassword').setValidators(Validators.required);
                        }
                })
        }
    }
    ////////////////////////////////////////////////////////#Gouhar///////////////////////////////////////////


    selectedUserObj() {

        return this._userSessionService.getSessionKey('userParms');
    }
    ////////////////////////////////////////////////////////#Gouhar///////////////////////////////////////////
    ngAfterViewInit() {
        this.activUserStepper$();
    }
    CheckPassword(inputtxt: string) {
        let passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;

        if (passw.test(inputtxt)) {
            //// alert('Correct, try another...')

            return true;
        }
        else {
            // alert('Wrong... Password should have lower and upper case!')
            this._toastService.activateMsg('pleaze write password have lower and uppercase and special');


            this.activeTab = 1

            return false;
        }
    }

    ngOnInit() {

        this.userInit();

        this._userSessionService.getSessionKey$('').pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                var tempUser = this.selectedUserObj();
                if (tempUser != (undefined || null) || Object.keys(tempUser).length != 0) {
                    this.userForm.get('password').clearValidators();
                    this.userForm.get('confirmPassword').clearValidators();
                    this.defaultPassword = tempUser['password'];
                    this._getUser(tempUser);
                }
                if (Object.keys(tempUser).length == 0) {
                    //this.usersGroupComponent.getGroupsReset();
                    this.userForm.reset();
                    this.userForm.get('password').setValidators(Validators.required);
                    this.userForm.get('confirmPassword').setValidators(Validators.required);
                }


                if (keys.name == 'userParms') {
                    tempUser = keys.value;
                    if (Object.keys(tempUser).length != 0) {
                        this.defaultPassword = tempUser['password'];
                        this._userSessionService.setSessionKey("editUserPassEnc", tempUser['password']);
                        tempUser['password'] = null;
                        tempUser['confirmPassword'] = null;
                        this.userForm.get('confirmPassword').setValue(null);
                        this.userForm.get('password').clearValidators();
                        this.userForm.get('confirmPassword').clearValidators();
                        this.userForm.patchValue(tempUser);
                        this.userForm.get('empId').setValue(tempUser['empID']);
                        if (this.usersGroupComponent)
                            this.usersGroupComponent.getGroups(tempUser);

                        this.seclOginSeclectize.setFastSearchKey('Type', tempUser['userID']);

                    }
                    else {
                        this.userForm.get('password').setValidators(Validators.required);
                        this.userForm.get('confirmPassword').setValidators(Validators.required);
                    }


                }
            });

        this._userSessionService.subscribeToKey$('ResetUser').pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.value) {
                    this.resetUser();
                    this.userForm.get('password').setValidators(Validators.required);
                    this.userForm.get('confirmPassword').setValidators(Validators.required);
                }
            });

        /////initial values for form

        this.userForm.get('password').setValidators(Validators.required);
        this.userForm.get('confirmPassword').setValidators(Validators.required);
    }
    
  get f() { return this.userForm.controls; }
    //++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//
    ////////////////////////////////////////////////////////#Gouhar///////////////////////////////////////////
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        this._userSessionService.setSessionKey('userParms', {});
    }

    resetUser() {
        this.userForm.reset();
        this.userForm.get('active').setValue(1);
        this.userForm.get('confirmPassword').setValue(null);
        this.userForm.get('password').setValidators(Validators.required);
        this.userForm.get('confirmPassword').setValidators(Validators.required);
        this.userForm.get('password').updateValueAndValidity();
        this.userForm.get('confirmPassword').updateValueAndValidity();
    }

    reset() {
        this.editUser = <User>{};
        this.editUser.active = true;
        this.userForm.get('confirmPassword').setValue(null);
        this.userForm.get('password').setValidators(Validators.required);
        this.userForm.get('confirmPassword').setValidators(Validators.required);
        this.userForm.get('password').updateValueAndValidity();
        this.userForm.get('confirmPassword').updateValueAndValidity();
    }


    //#region Crud operations

    _getUser(temp) {
        if (temp == null || temp == undefined || Object.keys(temp).length == 0) {
            this.editUser = <User>{};
            this.userForm.get('password').setValidators(Validators.required);
            this.userForm.get('confirmPassword').setValidators(Validators.required);
        }
        else {
            var id = temp.userID;
            this._userService.getUser(id).subscribe(
                user => {
                    this.editUser = user.msgData[0];
                    this.defaultPassword = this.editUser.password;
                }
            ),
                error => console.log(error),
                () => {
                    this.defaultPassword = this.editUser.password;
                    this._userSessionService.setSessionKey("editUserPassEnc", this.editUser.password);
                    this.editUser.password = null;
                    this.userForm.get('confirmPassword').setValue(null);
                    this.userForm.get('password').clearValidators();
                    this.userForm.get('confirmPassword').clearValidators();
                    this.updateDate=this.editUser.updateDate;
                    this.userForm.patchValue(this.editUser);
                }

        }
    }
    //++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//

    save() {
        //++++++++++++++++++++++++++++++++++Form Validations+++++++++++++++++++++++++++++++//
        this.editUser = this.userForm.value;
        if (this.editUser.empId == null) {
            this._toastService.activateMsg('UI37');
            return false;
        }
        if (this.editUser.defaultGroup == null) {
            this._toastService.activateMsg('UI42');
            return false;
        }
        if (this.userForm.get("userID").value == null) {
            this.userForm.get("userID").setValue(0)
        }
        if (this.userForm.get("userID").value == 0) {
            this.editUser.userID = 0;
            // if (!this.userForm.get('password').value) {
            //     this.editUser['password'] = (this._userSessionService.getSessionKey("editUserPassEnc"));
            // }
            if (this.userForm.get('password').value == undefined || this.userForm.get('password').value == null) {
                this.userForm.get('password').setValidators(Validators.required);
                this.userForm.get('confirmPassword').setValidators(Validators.required);
            }
            this._userService.addUser(this.editUser)
                .subscribe(c => {
                    if (c.data1.length > 0 && c) {
                        this.userForm.patchValue(c.data1[0])
                        this.userForm.get('empId').setValue(c.data1[0]['empID']);
                        this._userSessionService.setSessionKey('userParms', c.data1[0])
                        this.userCode = this.editUser.userID;
                        if (this.usersGroupComponent) {
                            this.usersGroupComponent.save();
                        }
                    }
                }
                );
        }
        else {
            if (this.userForm.get('password').value == undefined || this.userForm.get('password').value == null) {
                this.userForm.get('password').clearValidators();
                this.userForm.get('confirmPassword').clearValidators();
                this.editUser.password = this._userSessionService.getSessionKey("editUserPassEnc");
                //this.defaultPassword;
            }
            this._userService.updateUser(this.editUser)
                .subscribe(c => {
                    this.userForm.get('password').clearValidators();
                    this.userForm.get('confirmPassword').clearValidators();
                    if (c && c.data.length > 0)
                        this.userCode = this.editUser.userID;
                    if (this.usersGroupComponent)
                        this.usersGroupComponent.save();
                }


                );
        }

        //////to save more than one group
    }
    //++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//
    cancel(showToast = true) {
        this._goBack();
    }
    //++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//
    _goBack(): void {
        this._location.back();
    }


}
